import apiInstance from "../api/index";
import { getResFromJWTToken } from "../utils/decodeJWTRes";
import { login as loginAction } from "../store/slices/authSlice";
import toast from "react-hot-toast";

interface loginPayload {
  username: string;
  password: string;
}

interface registerPayload {
  firstName: string;
  lastName: string;
  password: string;
  email: string;
  confirmPassword: string;
}

export const login = async (
  payload: loginPayload,
  dispatch: any,
  navigate: any
) => {
  try {
    const { data } = await apiInstance.post("/auth/login", payload);
    const resData: any = getResFromJWTToken(data);
    if (resData?.status === "success") {
      dispatch(loginAction(resData.data));
      navigate("/dashboard");
    } else {
      toast.error(resData.message);
    }
    return;
  } catch (error: any) {
    console.error("Error fetching header data:", error?.message);
  }
};

export const loginWithGoogle = async (
  payload: any,
  dispatch: any,
  navigate: any
) => {
  try {
    const { data } = await apiInstance.post("/auth/social-register", payload);
    const resData: any = getResFromJWTToken(data);
    if (resData?.status === "success") {
      await dispatch(loginAction(resData.data));
      navigate("/dashboard");
    }
    return;
  } catch (error: any) {
    console.error("Error fetching header data:", error?.message);
  }
};

export const registerForm = async (data: any, navigate: any) => {
  try {
    const response = await apiInstance.post("/auth/register", data, {
      headers: {
        "User-Agent": "PostmanRuntime/7.42.0",
        Accept: "*/*",
        Connection: "keep-alive",
        "Accept-Encoding": "gzip, deflate, br",
      },
    });
    const resData: any = getResFromJWTToken(response.data);

    return resData;
  } catch (error: any) {
    console.error("Error fetching header data:", error?.message);
  }
};

export const contactForm = async (payload: any) => {
  try {
    const { data } = await apiInstance.post("/contact/sendquery", payload, {
      headers: {
        Connection: "keep-alive",
        Accept: "*/*",
        "Accept-Encoding": "gzip, deflate, br",
      },
    });
    const resData: any = getResFromJWTToken(data);
    if (resData?.status === "success") {
      toast.success(resData?.data?.message);
    }
    return resData;
  } catch (error: any) {
    console.error("Error fetching header data:", error?.message);
  }
};

export const updateUser = async (data: registerPayload) => {
  try {
    const response = await apiInstance.post("/update", data);
    return response.data.data;
  } catch (error: any) {
    console.error("Error fetching header data:", error?.message);
  }
};

export const logout = async (
  token: any,
  navigate: any,
  dispatch: any,
  logoutAction: any
) => {
  try {
    const response = await apiInstance.post(
      "/auth/logout",
      { token },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const decodedData: any = getResFromJWTToken(response.data);

    if (decodedData?.status === "success") {
      dispatch(logoutAction());
      navigate("/login");
    }
    return decodedData;
  } catch (error: any) {
    console.error("Error fetching header data:", error?.message);
  }
};
